import * as React from 'react';
var WeeklyBorderBottom = function (_a) {
    var styledProps = _a.styledProps;
    var _b = React.useState(600), cellHight = _b[0], setCellHight = _b[1];
    var _c = React.useState(800), timegridSlotWidth = _c[0], setTimegridSlotWidth = _c[1];
    var _d = React.useState(160), clientRectY = _d[0], setClientRectY = _d[1];
    var _e = React.useState(0), clientRectX = _e[0], setClientRectX = _e[1];
    React.useEffect(function () {
        var getCellWidth = function () {
            var clientRectY = 
            //@ts-ignore
            document.getElementById('topPositionDatesWrapper') !== null
                ? //@ts-ignore
                    document
                        .getElementById('topPositionDatesWrapper')
                        .getBoundingClientRect().bottom
                : 160;
            var clientRectX = document.getElementsByClassName('fc-timegrid-slot-label')[1] &&
                document
                    .getElementsByClassName('fc-timegrid-slot-label')[1]
                    .getBoundingClientRect().right;
            setClientRectY(clientRectY);
            setClientRectX(clientRectX);
            if (styledProps.isResponsive) {
                var todayCellHeight = document.getElementsByClassName('fc')[0] &&
                    document.getElementsByClassName('fc')[0].scrollHeight;
                setCellHight(todayCellHeight);
            }
            if (document.getElementsByClassName('fc-timegrid-slot').length > 0) {
                var timegridSlotWidth_1 = document
                    .getElementsByClassName('fc-timegrid-slot')[1]
                    .getBoundingClientRect().width;
                setTimegridSlotWidth(timegridSlotWidth_1 - styledProps.cellBorderWidth * 2);
            }
            if (!styledProps.isResponsive) {
                var prefixedBottomEl = document.getElementById('prefixedBottomPadding');
                var prefixedBottomBounding = prefixedBottomEl === null || prefixedBottomEl === void 0 ? void 0 : prefixedBottomEl.getBoundingClientRect();
                var daysHeaderHeight = 68.8;
                var controllersHeight = 84;
                daysHeaderHeight = getHeightByIdOrClassName('topPositionDatesWrapper', false, daysHeaderHeight);
                daysHeaderHeight = getHeightByIdOrClassName('calendarControllersRoot', false, controllersHeight);
                var calendarElemsHeight = prefixedBottomBounding &&
                    prefixedBottomBounding.top - (daysHeaderHeight + controllersHeight);
                setCellHight(calendarElemsHeight || 800);
            }
        };
        getCellWidth();
        window.addEventListener('resize', function () { return getCellWidth(); });
        return function () { return window.addEventListener('resize', function () { return getCellWidth(); }); };
    });
    var topPosition = styledProps.isResponsive
        ? cellHight + clientRectY - styledProps.cellBorderWidth
        : cellHight + clientRectY - styledProps.cellBorderWidth;
    return (React.createElement("div", { style: {
            position: 'absolute',
            width: "".concat(timegridSlotWidth + styledProps.cellBorderWidth * 2, "px"),
            top: "".concat(topPosition, "px"),
            borderBottom: "".concat(styledProps.cellBorderWidth, "px solid ").concat(styledProps.cellBorderColor),
            zIndex: 9,
            left: "".concat(clientRectX, "px"),
            pointerEvents: 'none',
        } }));
};
export default WeeklyBorderBottom;
var getHeightByIdOrClassName = function (artifact, isClassName, defaultValue) {
    var height = defaultValue;
    var ell = isClassName
        ? document.getElementsByClassName(artifact)[0]
        : document.getElementById(artifact);
    var ellBoundingClientRect = ell && ell.getBoundingClientRect();
    height = (ellBoundingClientRect === null || ellBoundingClientRect === void 0 ? void 0 : ellBoundingClientRect.height) || defaultValue;
    return height;
};
//# sourceMappingURL=WeeklyBorderBottom.js.map